import { Chip, Tooltip } from '@mui/material'
import PeopleIcon from '@mui/icons-material/PeopleAlt'
import { projectRoleLabels, type ProjectRole } from '../api/types'

interface Props {
  role: ProjectRole
  ownerEmail?: string
  sharedWithOthers?: boolean
}

// Marks an item (project or simulation) that is shared: a role chip when it
// was shared with the current user, a share icon when the user owns it and
// has shared it with others.
export default function SharedBadge({ role, ownerEmail, sharedWithOthers }: Props) {
  if (role === 'owner') {
    if (!sharedWithOthers) return null
    return (
      <Tooltip title="Partagé avec d'autres utilisateurs">
        <PeopleIcon
          fontSize="small"
          aria-label="Partagé avec d'autres utilisateurs"
          sx={{ alignSelf: 'center', verticalAlign: 'middle' }}
        />
      </Tooltip>
    )
  }
  const chip = <Chip size="small" color="info" variant="outlined" label={projectRoleLabels[role]} />
  return ownerEmail ? <Tooltip title={`Partagé par ${ownerEmail}`}>{chip}</Tooltip> : chip
}
